import React from 'react'
import { Badge } from 'react-bootstrap'
import { Card, Image, Action, Description } from './style'

const HomeCard = ({ onClick, icon, title, description, badge, ...rest }) => (
  <Card onClick={onClick} {...rest}>
    {
      badge > 0 &&
      <div className="text-right">
        <Badge pill variant="warning" className="small-font">
          {badge}
        </Badge>
      </div>
    }
    <div>
      <Image src={icon} />
      <Action>{title}</Action>
    </div>
    <Description>{description}</Description>
  </Card>
)

export default React.memo(HomeCard)
